export default __webpack_public_path__ + "static/Fig 13 - 132kV Compound-4b9371e1d388b00588199bb10584f9d1.pdf";